export default "<!--<p>{{ message | async }}</p>-->\n\n<!--<button type=\"button\" (click)=\"login()\">Log In </button>-->\n"